export default {
  data() {
    return {
      resizeRepeatTimeout: null,
      width: 0,
      height: 0,
      gridConfig: {
        0: {
          default: { x: 2, y: 1, infinite: true },
          tablet: { x: 1, y: 1, infinite: true },
          mobile: { x: 1, y: 2, infinite: true },
          wide: { x: 3, y: 1, infinite: true },
        },
        500: {
          default: { x: 2, y: 1, infinite: true },
          tablet: { x: 2, y: 2, infinite: true },
          mobile: { x: 1, y: 2, infinite: true },
          wide: { x: 3, y: 1, infinite: true },
        },
        768: {
          default: { x: 2, y: 1, infinite: true },
          tablet: { x: 2, y: [2, 3], infinite: true },
          mobile: { x: 2, y: [3, 4], infinite: true },
          wide: { x: 3, y: 1, infinite: true },
        },
        992: {
          default: { x: 3, y: 2 },
          tablet: { x: 2, y: [2, 3, 4] },
          mobile: { x: 2, y: [3, 4] },
          wide: { x: 3, y: 1 },
        },
        1200: {
          default: { x: [3, 4], y: 2 },
          tablet: { x: 3, y: [2, 3] },
          mobile: { x: 2, y: [2, 3] },
          wide: { x: [3, 4], y: 1 },
        },
      },
    };
  },
  computed: {
    resolution() {
      return this.width / this.height;
    },
    wide() {
      return this.resolution >= 3.4;
    },
    tablet() {
      return this.resolution < 1.5 && this.resolution >= 0.8;
    },
    mobile() {
      return this.resolution < 0.8;
    },
    length() {
      return this.auctions ? this.auctions.length : 0;
    },
    gridGroup() {
      let result = [];

      Object.keys(this.gridConfig).forEach((size) => {
        if (size <= this.width) {
          result = this.gridConfig[size];
        }
      });

      return result;
    },
    grid() {
      if (this.gridSingle) {
        return { x: 1, y: 1 };
      }

      // Find grid group by screen width

      let group = null;

      Object.keys(this.gridConfig).forEach((size) => {
        if (size <= this.width) {
          group = this.gridConfig[size];
        }
      });

      // Find grid by screen resolution

      let grid = group.default;

      if (this.wide && group.wide) {
        grid = group.wide;
      }

      if (this.tablet && group.tablet) {
        grid = group.tablet;
      }

      if (this.mobile && group.mobile) {
        grid = group.mobile;
      }

      // Set final params

      const Xs = typeof grid.x === 'number' ? [grid.x] : grid.x.sort();
      const Ys = typeof grid.y === 'number' ? [grid.y] : grid.y.sort();

      let result = { x: Xs[0], y: Ys[0] };

      Xs.forEach((x) => {
        Ys.forEach((y) => {
          if (this.length > this.getGridLimit(result)) {
            result = { x, y };
          }
        });
      });

      result.infinite = grid.infinite;

      return result;
    },
    gridLimit() {
      return this.getGridLimit(this.grid);
    },
    emptySlots() {
      if (this.gridLimit && this.gridLimit > this.length) {
        return this.gridLimit - this.length;
      }
      return this.grid.x === 1 ? 0 : this.length % this.grid.x;
    },
    gridItemSize() {
      const columns = this.grid.x;
      const rows = this.grid.y;

      const width = (1 / columns) * this.width;
      const height = rows ? (1 / rows) * this.height : this.height;

      const scale = (1920 / 4) / width;
      const proportions = width / height;

      return { width, height, scale, proportions };
    },
    gridStyle() {
      return {
        width: '100%',
        height: this.gridLimit ? '100%' : `${this.gridItemSize.height * Math.ceil(this.length / this.grid.x)}px`,
      };
    },
    gridClass() {
      return {
        grid: true,
        'grid--wide': this.wide,
        'grid--tablet': this.tablet,
        'grid--mobile': this.mobile,
      };
    },
    gridItemClass() {
      return {
        grid__item: true,
        'grid__item--wide': this.gridItemSize.proportions > 1.1,
        'grid__item--x-wide': this.gridItemSize.proportions > 1.5,
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.$nextTick(() => {
      this.onWindowResize();
    });

    setTimeout(this.onWindowResize, 100);
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    onWindowResize(stop) {
      this.width = this.$el.clientWidth;
      this.height = this.$el.clientHeight;

      if (!stop) {
        clearTimeout(this.resizeRepeatTimeout);
        this.resizeRepeatTimeout = setTimeout(this.onWindowResize(true), 1000);
      }
    },
    getGridLimit(grid) {
      if (!grid.x || !grid.y || grid.infinite) {
        return 0;
      }

      return grid.x * grid.y;
    },
    gridItemStyle(i) {
      const columns = this.grid.x;

      const col = this.gridLimit && i >= this.gridLimit ? columns : Math.floor(i % columns);
      const row = Math.floor(i / columns);

      const scale = this.gridItemSize.scale;
      const width = this.gridItemSize.width;
      const height = this.gridItemSize.height;
      const transform = `translate3d(${width * col}px, ${height * row}px, 0)`;

      return {
        width: `${width}px`,
        height: `${height}px`,
        fontSize: `calc(10em / ${scale * 10})`,
        transform,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/SmartGrid.js